export default {
  CONTROL_WARNING_TITLE: 'Legal points to review',
  CONTROL_WARNING_TEXT: 'The document was generated, but some provided elements may create a legal risk or contradiction. Please review them before use.',
  CONTROL_WARNING_ACK: 'I have read and understood',
  GERER: {
    TITRE: 'My documents',
    BTN: 'Query your documents',
    CREATEDOC: 'Create document',
    FILTER1: {
      TOUS: 'All employees',
      PRIVATE: 'Private',
      TEAM: 'Team',
      Site: 'Site',
    },
    FILTER2: {
      ATTENTE: 'Pending',
      INDEXATION: 'Indexing...',
      INDEXE: 'Indexed',
      ERR: 'Error',
    },
    TABLE: {
      COL1: 'Document name',
      COL2: 'Visibility',
    },
  },
  CONTRACT: {
    ASSOCIATE: 'Link document to contract',
    ASSOCIATED: 'Document linked to contract successfully',
    DISSOCIATED: 'Document unlinked from contract successfully',
    ASSOCIATION_ERROR: 'Error linking the document to the contract',
    DISSOCIATION_ERROR: 'Error unlinking the document from the contract',
    LOAD_ERROR: 'Unable to load documents linked to the contract. Refresh before changing document links.',
  },
  INTERROGER: {
    REP: 'Short answer',
    Source: 'Source',
    Extrait: 'Extract',
    LOADING: 'Loading document...',
    TXT: 'You can query your documents',
    BTN_NEW: 'New question',
    BTN_CLOSE: 'Close',
  },
  UPLOAD: {
    title: 'Add documents',
    txt: 'Please import your documents',
    error:
      '*Free accounts are limited to pdf files of 30 pages max and 5MB max. If you wish to lift these limits, you can upgrade to the premium offer.',
    visibilite: 'Change document visibility',
    prive: 'Private',
    equipe: 'Team',
    site: 'Site',
    ts: 'All',
    doc_selectionne: 'Selected documents',
    Fermer: 'Close',
    En_cours: 'In progress...',
    Soumettre: 'Submit',
    SUCCESS: '{{name}}: uploaded successfully. Please wait while processing completes.',
    CONTRACT_SUCCESS: '{{name}}: document uploaded and linked to the contract. Processing is in progress.',
    UPLOAD_ERROR: '{{name}}: document upload failed. You can retry using Submit.',
    INVALID_RESPONSE: '{{name}}: upload did not return a valid document ID. Check the DMS before retrying.',
    SUBSCRIPTION_ERROR: '{{name}}: your subscription is not valid.',
    TEMPORARY_ERROR: '{{name}}: temporary error. Please try again later.',
    CREDIT_ERROR: '{{name}}: insufficient credits to upload the document.',
    ASSOCIATION_RETRY_ERROR: '{{name}}: document uploaded, but linking to the contract failed. Click Submit to retry linking without uploading the file again.',
  },
  EDIT: {
    title: 'Document details',
    EN_ATTENTE: 'Waiting',
    INDEXATION: 'Indexation...',
    INDEXE: 'Indexed',
    ERR: 'Error',
    titre_doc: 'Document title',
    auteur: 'Author',
    IMPORTEEPAR: 'Imported by',
    DATE: 'Import date',
    nbrPages: 'Number of pages',
    Version: 'Version',
    Sujet: 'Subject',
    Resume: 'Summary',
    listUser: 'List of users concerned',
    Email: 'Email',
    Telephone: 'Phone',
    Entreprise: 'Company',
    Fonction: 'Function',
    listeVide: 'No users concerned',
    add: 'Add',
    addUser: {
      title: 'Add users',
      txt: 'Select the user to add to the user list',
    },
  },
  GENERATION_ASSISTANT: {
    TITLE: 'AI assistant',
    SUBTITLE: 'Complete missing information before generation.',
    WELCOME: 'I can check collaborator information and prepare more precise instructions. You can generate the document at any time, but answering the questions helps produce a more complete document and reduces default values or sections to review.',
    SELECT_COLLABORATOR: 'Select a collaborator first so I can check the available information.',
    OPEN: 'AI assistant',
    HIDE: 'Hide assistant',
    THINKING: 'Analyzing...',
    READY: 'Ready',
    MISSING_STATUS: 'Missing info',
    MISSING_MODAL_TITLE: 'Missing information',
    MISSING_MODAL_TEXT: 'Some information still seems to be missing. You can go back to the assistant to complete it or generate anyway.',
    BACK_TO_ASSISTANT: 'Back to assistant',
    CONTINUE_ANYWAY: 'Generate anyway',
    RETAINED_INSTRUCTIONS: 'Retained instructions',
    INPUT_PLACEHOLDER: 'Add a detail or answer the question...',
    APPLY: 'Use these instructions',
    APPLIED: 'Instructions applied',
    AUTO_USED: 'These instructions will be used automatically when generating.',
    MANUAL_EDIT: 'Edit manually',
    HIDE_MANUAL: 'Hide manual input',
    MANUAL_LABEL: 'Additional manual instruction',
    MANUAL_PLACEHOLDER: 'Ex: do not include the signature, write in English, add a note for the bank...',
    NO_INSTRUCTIONS: 'No specific instruction yet. Use the AI assistant to refine the document.',
    ERROR: 'Error while calling the assistant',
    GENERATION_ERROR: 'Error while generating the document',
    SKIP_OPTIONAL: 'Skip',
    AI_WARNING: 'AI-GENERATED DOCUMENT. This document was generated automatically and does not constitute legal advice. Verify its compliance (collective bargaining agreement, Labor Code) before signing or distribution.',
    LOADING_PREPARE: 'Preparing the document...',
    LOADING_GENERATING: 'Generating the document...',
    LOADING_CONTROLLING: 'Quality control in progress...',
    LOADING_CORRECTING: 'Applying corrections...',
    LOADING_FINALIZING: 'Finalizing the document...',
    GENERATION_PAUSED_TITLE: 'Information needed',
    GENERATION_PAUSED_TEXT: 'Answer the question below to continue generating the document.',
    JULIE_ENABLED: 'Julie enabled',
    JULIE_DISABLED: 'Julie disabled',
  },
  FOLDER: {
    CREATE: {
      TITLE: 'Create new folder',
      NAME_LABEL: 'Folder name',
      NAME_PLACEHOLDER: 'Enter folder name',
      NAME_REQUIRED: 'Folder name is required',
      COLLABORATOR: 'Collaborator',
      OPTIONAL: 'optional',
      SUBMIT: 'Create',
      SUCCESS: 'Folder created successfully',
      ERROR: 'Error creating folder',
      SELECT_TEAM: 'Please select a team',
      SELECT_SITE: 'Please select a site',
    },
    RENAME: {
      TITLE: 'Rename folder',
      NEW_NAME_LABEL: 'New name',
      NEW_NAME_PLACEHOLDER: 'Enter the new name',
      NAME_REQUIRED: 'Name is required',
      PARENT_LABEL: 'Parent folder',
      OPTIONAL: 'optional',
      ROOT_OPTION: 'Root',
      SAVE: 'Save',
      INVALID_PARENT: 'A folder cannot be its own parent',
      SUCCESS: 'Folder updated',
      ERROR: 'Error updating folder',
    },
    LIST: {
      CREATE_FOLDER_BTN: 'Create folder',
      ROOT: 'Root',
      SECTION_TITLE: 'Folders',
      EMPTY_TITLE: 'No folders',
      EMPTY_SUBTITLE: 'Create your first folder to organize your documents',
      RENAME_TOOLTIP: 'Rename folder',
      DELETE_TOOLTIP: 'Delete folder',
    },
    MOVE_TO_FOLDER: 'Move to folder',
    DELETE: {
      TITLE_FOLDER: 'Delete folder',
      TITLE_DOCUMENT: 'Delete document',
      DELETION_OF: 'Deletion of "{{name}}"',
      DELETING_FOLDER: 'Deleting folder...',
      DELETING_DOCUMENT: 'Deleting document...',
      FOLDER_CONFIRMATION: 'Are you sure you want to delete this folder? All documents it contains will be deleted as well.',
      CONFIRMATION_GENERIC: 'Are you sure you want to permanently delete this item?',
      CONFIRM_LABEL: 'To confirm deletion, please type "{{confirm}}" below:',
      CONFIRM_PLACEHOLDER: 'Type {{confirm}} to confirm',
      CONFIRM_MISMATCH: 'The text does not match. Type exactly "{{confirm}}" to confirm.',
      ERROR_GENERIC: 'An error occurred while deleting.',
      CANCEL: 'Cancel',
      DELETE: 'Delete',
      DELETING: 'Deleting...',
      CONFIRM_WORD: 'Delete',
      SUCCESS_FOLDER: 'Folder deleted successfully',
      ERROR_FOLDER: 'Error deleting folder',
    },
    ACTIONS: {
      CANCEL: 'Cancel',
      SAVE: 'Save',
      SELECT_FOLDER_REQUIRED: 'Please select a folder',
    },
    ERRORS: {
      NOT_FOUND: 'Folder not found',
      LOAD_DOCS_ERROR: 'Error loading folder documents',
    },
    SCOPE: {
      ADMINS: 'Admins',
      UNDEFINED: 'Undefined',
    },
  },
}
